export const PAYMENT_METHODS = {
  applePay: 'applePay',
  cc: 'cc',
  payPal: 'payPal',
};
